import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Mission} from 'src/app/storage/models/mission.model';
import {IMission} from 'src/app/storage/interfaces/mission.interface';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from './api.service';
import { HttpClient } from "@angular/common/http";
import {IApiResponse} from "../../storage/interfaces/api.interface";
import {IQuestionnaireForApi} from "../../storage/interfaces/questionnaire.interface";
import {Router} from "@angular/router";

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class MissionsService {

  missions$: BehaviorSubject<Mission[]> = new BehaviorSubject([]);
  selectedMission$: BehaviorSubject<Mission> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService,
    private _http: HttpClient,
    private _router: Router
  ) {
  }

  async getMissions(): Promise<void> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const response = await this.apiService.get(
      `${URL}missions`,
      translations['LABEL'],
      {showLoader: true}
    );

    if (response != null) {
      const missions: Mission[] = response.missions.map((mission: IMission) => new Mission(mission));
      this.missions$.next(missions);
    }
  }

  async updateMissionSiteWellawareId(missionId: string, siteWellawareId: string): Promise<boolean> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const payload = {siteWellawareId};

    const response = await this.apiService.post(
      `${URL}missions/sitewellaware/${missionId}`,
      payload,
      translations['LABEL'],
      {showLoader: true}
    );

    return response != null;
  }

  async updateMissionProductStatus(missionId: string, productstatus: number): Promise<boolean> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const payload = {
      productstatus: productstatus
    };

    const response = await this.apiService.post(
      `${URL}missions/productstatus/${missionId}`,
      payload,
      translations['LABEL'],
      {showLoader: true}
    );

    return response != null;
  }

  async updateMissionTeamStatus(missionId: string, teamstatus: number): Promise<boolean> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const payload = {
      teamstatus: teamstatus
    };

    const response = await this.apiService.post(
      `${URL}missions/teamstatus/${missionId}`,
      payload,
      translations['LABEL'],
      {showLoader: true}
    );

    return response != null;
  }

  async updateMissionMaterialStatus(missionId: string, materialstatus: number): Promise<boolean> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const payload = {
      materialstatus: materialstatus
    };

    const response = await this.apiService.post(
      `${URL}missions/materialstatus/${missionId}`,
      payload,
      translations['LABEL'],
      {showLoader: true}
    );

    return response != null;
  }

  async updateMissionSupportStatus(missionId: string, supportstatus: number): Promise<boolean> {
    const translations = await this.translateService.get('MISSIONS').toPromise();

    const payload = {
      supportstatus: supportstatus
    };

    const response = await this.apiService.post(
      `${URL}missions/supportstatus/${missionId}`,
      payload,
      translations['LABEL'],
      {showLoader: true}
    );

    return response != null;
  }

  createNewMission(missionData: IQuestionnaireForApi): Observable<IApiResponse<boolean>> {
    return this._http.put<IApiResponse<boolean>>(`${URL}missions/create`, missionData);
  }

  async selectMission(missionId: string): Promise<void> {
    await this.getMissions();
    const missions = this.missions$.getValue();
    const foundMission = missions.find(m => m.missionId === missionId);
    if (!!foundMission) {
      this.selectedMission$.next(foundMission);
    }
    return;
  }
}